<template>
    <section>
        <!--<img src="~@/assets/login2_full_bg.jpg" alt="Full Background" class="animation-pulseSlow" width="1920" height="1080"/>-->

        <div style="background: #ebf1f2; height: 1080px"></div>

        <div id="login-container">
            <!--<h1 class="h2 text-light text-center push-top-bottom" style="margin-bottom: 30px !important"><img src="~@/assets/numerama_marca_login.png"></h1>-->

            <div class="block animation-fadeInQuick">
                <div class="block-title">
                    <h2>Login</h2>
                </div>

                <form method="POST" accept-charset="UTF-8" class="form-horizontal" v-on:keyup.13="login">
                    <div class="form-group">
                        <label for="email" class="col-xs-12">E-mail</label>
                        <div class="col-xs-12">
                            <input type="text" id="email" name="email" class="input-email form-control"
                                   placeholder="Digite seu e-mail..." v-model="user.email">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="password" class="col-xs-12">Senha</label>
                        <div class="col-xs-12">
                            <input type="password" id="password" name="password" class="form-control"
                                   placeholder="Digite sua senha..." v-model="user.password">
                        </div>
                    </div>

                    <div class="form-group form-actions">

                        <div class="col-xs-12">
                            <button type="button" @click="login" class="btn btn-effect-ripple btn-sm btn-success pull-left">
                                Entrar
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <footer class="text-muted text-center">
                <small><span id="year-copy">2014-18</span> © RBR Sistemas</small>
            </footer>
        </div>

    </section>

</template>

<script>

    export default {
        name: 'login',
        data() {
            return {
                empresas: [],
                user: {}
            }
        },
        methods: {


            login() {

                this.$store.dispatch('doLogin', this.user).then((response) => {
                    this.$store.dispatch('updateCheckuser');
                    this.$store.dispatch('getUser');
                    this.$store.dispatch('setConfiguracao')
                    this.$http.post('api/getLogo').then((response) => {
                        $('#logoMarca').attr('src', 'data:image/jpeg;charset=utf-8;base64,' + response.data.logo)
                    });
                    return this.$router.push({'name': 'home'});
                }).catch(() => {
                    window.swal({
                        'title': 'Atenção!',
                        'text': "As informações de login não foram encontradas.",
                        'type': 'warning'
                    });
                })
            }
        },
        mounted() {
//            this.$set(this, 'user', {email: 'mauricio@rbrinformatica.com.br', password: '123456'})
//            this.login()
        }
    }
</script>

<style scoped>
    #login-container {
        position: absolute;
        width: 300px;
        top: 30px;
        left: 50%;
        margin-left: -150px;
        z-index: 1000;
    }

    /* General */
    #login-container {
        width: 380px;
        top: 100px;
        margin-left: -190px;
    }

    .block {
        -webkit-box-shadow: 0 2px 0 rgba(218, 229, 232, .5);
        box-shadow: 0 2px 0 rgba(218, 229, 232, .5);
    }

    .block {
        margin: 0 0 10px;
        padding: 20px 15px 1px;
        background-color: #ffffff;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        -webkit-box-shadow: 0 2px 0 rgba(218, 224, 232, .5);
        box-shadow: 0 2px 0 rgba(218, 224, 232, .5);
    }

    .block-title {
        background: rgba(218, 229, 232, .15);
        margin: -20px -15px 20px;
        border-bottom: 2px solid #dae0e8;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
    }

    .block-title:hover {
        border-bottom-color: #dae5e8;
    }

    .block-title h1, .block-title h2, .block-title h3, .block-title h4, .block-title h5, .block-title h6 {
        display: inline-block;
        font-size: 14px;
        line-height: 1.4;
        margin: 0;
        padding: 10px 15px 9px;
        font-weight: 600;
        text-transform: uppercase;
    }

    body {
        overflow: hidden;
    }
</style>
